"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactBodyClassname = require("react-body-classname");

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _components = require("components");

var _Translate = require("../../redux/i18n/Translate");

var _Translate2 = _interopRequireDefault(_Translate);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

var _mobile = require("redux/modules/mobile");

var mobileActions = _interopRequireWildcard(_mobile);

var _overflowBody = require("redux/modules/overflowBody");

var overflowBodyActions = _interopRequireWildcard(_overflowBody);

var _prueba = require("./prueba.scss");

var _prueba2 = _interopRequireDefault(_prueba);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Prueba = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return {
    isMobile: state.mobile.isMobile,
    isTablet: state.mobile.isTablet,
    overflowBody: state.overflowBody.overflowBody
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)((0, _extends3.default)({}, mobileActions, overflowBodyActions), dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Prueba, _Component);

  function Prueba(props) {
    (0, _classCallCheck3.default)(this, Prueba);
    return (0, _possibleConstructorReturn3.default)(this, (Prueba.__proto__ || (0, _getPrototypeOf2.default)(Prueba)).call(this, props));
  }

  (0, _createClass3.default)(Prueba, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var strings = this.props.strings;


      var classBody = (0, _classnames2.default)({
        prueba: true,
        isMobile: this.props.isMobile,
        isTablet: this.props.isTablet,
        overflowBodyHide: !this.props.overflowBody
      });

      var items = strings.carousel.map(function (elem, indexElem) {
        var videos = elem.videos.map(function (videosElem, indexVideosElem) {
          return _react2.default.createElement(
            "div",
            {
              className: "sliderItem__video",
              key: "carouselVideosElem" + indexVideosElem
            },
            _react2.default.createElement(_components.ContainerVideo, {
              strings: videosElem,
              index: indexElem
            })
          );
        });
        return _react2.default.createElement(
          "div",
          { key: "slider" + indexElem },
          _react2.default.createElement(
            "div",
            { className: "sliderItem" },
            videos
          )
        );
      });

      var items2 = strings.carousel.map(function (elem, indexElem) {
        var videos2 = elem.videos.map(function (videosElem, indexVideosElem) {
          return _react2.default.createElement(
            "div",
            {
              className: "itemsVideo",
              key: "carouselVideosElem2" + indexVideosElem
            },
            _react2.default.createElement("video", { src: "https://hay.github.io/test/dog.mp4", playsInline: true, muted: true, autoPlay: true }),
            _react2.default.createElement("video", { src: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco/franco-traslado-v1.mp4", playsInline: true, muted: true, autoPlay: true })
          );
        });
      });

      var items3 = strings.carousel.map(function (elem, indexElem) {
        var videos3 = elem.videos.map(function (videosElem, indexVideosElem) {
          return _react2.default.createElement(
            "div",
            {
              className: "itemsVideo",
              key: "carouselVideosElem2" + indexElem + indexVideosElem
            },
            _react2.default.createElement(_components.VideoPlayer, {
              onRef: function onRef(ref) {
                return _this2.videoPlayerRef = ref;
              },
              idVideo: "videojs-vr-player-" + indexElem + indexVideosElem,
              urlVideoDesktop: videosElem.video.videoSrc,
              urlVideoMobile: videosElem.video.videoSrcMobile,
              videoType: "video/mp4",
              titleVideo: "Elcano 360",
              programTitle: "Elcano",
              duration: "585" })
          );
        });
        return _react2.default.createElement(
          "div",
          { key: "slider2" + indexElem },
          _react2.default.createElement(
            "div",
            null,
            videos3
          )
        );
      });

      return _react2.default.createElement(
        _reactBodyClassname2.default,
        { className: classBody },
        _react2.default.createElement(
          "main",
          { className: "view" },
          _react2.default.createElement(
            "div",
            { className: "content" },
            items3
          )
        )
      );
    }
  }]);
  return Prueba;
}(_react.Component), _class2.displayName = "Prueba", _class2.propTypes = {
  strings: _propTypes2.default.object
}, _class2.contextTypes = {
  baseUrl: _propTypes2.default.string.isRequired,
  project: _propTypes2.default.string.isRequired
}, _temp)) || _class);
exports.default = (0, _Translate2.default)("Home")(Prueba);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Prueba/Prueba.js
// module id = 719
// module chunks = 0